import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { OrganizationLogo } from '../Svgs'

interface OrganizationInfoProps {}

const OrganizationInfoComponent: React.FC<OrganizationInfoProps> = () => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box
        display={'flex'}
        gap={'10px'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <OrganizationLogo />
        <Typography
          sx={{
            color: '#04002E',
            fontSize: '0.94rem',
            lineHeight: 'normal',
            fontWeight: 500,
          }}
        >
          Company Name
        </Typography>
      </Box>
      <Box display={'flex'} gap={'4px'}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            minWidth: '132px',
            background: '#F5F5F5',
            border: 'none',
            color: '#797979',
            fontSize: '0.76rem',
            fontWeight: 500,
            padding: '8px 0',
            borderRadius: '4px',
          }}
        >
          email@email.com
        </Box>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            minWidth: '132px',
            background: '#F5F5F5',
            border: 'none',
            color: '#797979',
            fontSize: '0.76rem',
            fontWeight: 500,
            padding: '8px 0',
            boxSizing: 'border-box',
            borderRadius: '4px',
          }}
        >
          555 555 5555
        </Box>
      </Box>
    </Box>
  )
}

export default OrganizationInfoComponent
